import { LinkButton } from '@atlaskit/button/new';
import FeedbackIcon from '@atlaskit/icon/glyph/feedback';
import { useIntl } from 'react-intl-next';

import { useAnalyticsWebClient } from '../../../../utils/analytics/context';

import messages from './messages';

export const FeedbackButton = () => {
	const analyticsWebClient = useAnalyticsWebClient();
	const { formatMessage } = useIntl();
	return (
		<LinkButton
			iconBefore={FeedbackIcon}
			appearance="subtle"
			target="_blank"
			href="https://atlassian.enterprise.slack.com/archives/C08TMKPDKUY"
			onClick={() => {
				analyticsWebClient.sendUIEvent({
					action: 'clicked',
					actionSubject: 'button',
					actionSubjectId: 'boysenberry-feedback-button',
					source: 'boysenberry-sidebar',
				});
			}}
		>
			{formatMessage(messages.feedbackButtonLabel)}
		</LinkButton>
	);
};
